import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import {WhatsappService} from '../../pages/page-whatsapp/whatsapp.service';
import {BehaviorSubject, Subject, takeUntil} from 'rxjs';
import {IMessengerConnector} from '../../types/all.type';
import {AppService} from '../../services/app.service';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';


@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() avatar: string;
  public avatar$: BehaviorSubject<string> = new BehaviorSubject('');
  public color$: BehaviorSubject<string> = new BehaviorSubject('');
  @Input() avatarFileId = '';
  @Input() avatarFileUniqueId = '';
  @Input() serviceType = '';
  @Input() type: string;
  @Input() id: string | number;
  @Input() force: boolean;
  @Input() Service: IMessengerConnector;
  private destroy$: Subject<void> = new Subject();
  seed!: number;

  constructor(
    private cd: ChangeDetectorRef,
    private allMessengersService: AllMessengersService,
    private appService: AppService,
  ) {
  }

  ngOnChanges() {
    this.change();
  }

  loadImageError(event) {
    this.avatar$.next('');
  }

  ngOnInit(): void {
    this.setSeedId();
    // this.change();
    // this.cd.detectChanges();

  }

  change(): void {
    this.setSeedId();
    if (this.id === 'manager') {
      this.color$.next('#1565C0');
    } else if (this.id === 'sender') {
      this.color$.next('#068bcd');
    } else if (this.id === 'partner') {
      this.color$.next('#42ba96');
    } else if (this.type === 'support') {
      this.color$.next('#068bcd');
    } else {
      this.color$.next(this.appService.stringToHslColor(this.id));
    }

    if (this.Service instanceof WhatsappService) {
      this.Service.getAvatar(this.id).pipe(takeUntil(this.destroy$)).subscribe((avatar) => {
        this.avatar$.next(avatar);
        this.cd.detectChanges();
      });
    }

    if (this.avatarFileId && (!this.avatar$.value || this.force)) {
      const Service = this.serviceType ? this.allMessengersService.getService(this.serviceType) : this.Service;
      try {
        Service.getFile$(this.avatarFileId, this.avatarFileUniqueId)
          .pipe(takeUntil(this.destroy$))
          .subscribe((result: any) => {
            this.avatar$.next(result.file);
            this.cd.detectChanges();
          });
      } catch (e) {
        console.error('Service.getFile$ undefined', Service?.type, e);
      }
    } else {
      this.avatar$.next('');
    }
  }

  setSeedId() {
    this.seed = typeof this.id === 'number' ? this.id : this.stringToNumber(this.id);
  }

  private stringToNumber(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // 32-bit int
    }
    return Math.abs(hash);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
